import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const validateSSODomain = api(async function validateSSODomain(domain, clientId) {
    return await query(
        gql`
            query validateSSODomain($domain: String!, $clientId: String) {
                validateSSODomain(domain: $domain, clientId: $clientId) {
                    valid
                    error
                }
            }
        `,
        { domain, clientId },
        { returns: "validateSSODomain", fetchPolicy: "network-only" }
    )
})
